const initialState = {
  feedList: [],
  totalRecord: 0,
  feed: {},
};

const feed = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_FEED_LIST": {
      const feedList = action.payload.rows;
      const totalRecord = action.payload.count;
      if (action.initialFetch)
        return {
          ...state,
          feedList,
          totalRecord,
        };
      else
        return {
          ...state,
          feedList: [...state.feedList, ...feedList],
          totalRecord,
        };
    }
    case "CREATE_FEED_CONTENT": {
      const newFeed = action.payload;
      return {
        ...state,
        feedList: [newFeed, ...state.feedList],
        totalRecord: state.totalRecord + 1,
      };
    }
    case "EDIT_FEED_CONTENT": {
      let index = state.feedList.findIndex((fl) => fl.id === action.payload.id);
      let feedList = [...state.feedList];
      feedList[index] = action.payload;
      return {
        ...state,
        feedList,
      };
    }
    case "DELETE_FEED_CONTENT": {
      var deletedList = state.feedList.filter(
        (x) => !action.payload.includes(x.id)
      );
      return {
        ...state,
        feedList: [...deletedList],
        totalRecord: state.totalRecord - 1,
      };
    }
    case "GET_FEED_CONTENT": {
      return {
        ...state,
        feed: action.payload,
      };
    }
    case "FEED_LIKE": {
      let index = state.feedList.findIndex((fl) => fl.id === action.payload.id);
      let feedList = [...state.feedList];
      feedList[index] = action.payload;
      return {
        ...state,
        feedList,
      };
    }
    case "FEED_UNLIKE": {
      let index = state.feedList.findIndex((fl) => fl.id === action.payload.id);
      let feedList = [...state.feedList];
      feedList[index] = action.payload;
      return {
        ...state,
        feedList,
      };
    }
    default:
      return state;
  }
};

export default feed;
